import * as yup from 'yup'

export const CouponSchmea = yup.object().shape({
  name:yup.string().min(3,"1:Promotional Group Name must include at least 3 characters").matches(/^[a-zA-Z0-9]+$/, '1:No special characters allowed').required("1:Promotional Group Name is required"),
  expiry:yup.number().min(1,"2:Duration Field is required").required("2:Duration Field is required"),
  code:yup.number().min(1,"3:Number of Promo Codes must be greater than 0").max(10000,"3:Number of Promo Codes must not be greater than 10,000").required("3:Number of Promo Codes is required"),
  subscriptionPlan:yup.string().required("4:Subscription Plan is required")
});
